import { render, staticRenderFns } from "./ManagePostcodes.vue?vue&type=template&id=7c08eb92&"
import script from "./ManagePostcodes.vue?vue&type=script&lang=js&"
export * from "./ManagePostcodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports